import { IframeWrapper } from "@stardeck-customer-apps/client-utils";
import { AuthProvider } from "@stardeck-customer-apps/project-auth";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";

import { queryClient } from "@/lib/react-query";

interface ProvidersProps {
  children: React.ReactNode;
}

export const Providers = ({ children }: ProvidersProps) => {
  return (
    <IframeWrapper>
      <AuthProvider
        signInPath="/auth/login"
        signOutPath="/auth/logout"
        sessionCheckPath="/api/auth/me"
      >
        <QueryClientProvider client={queryClient}>
          {children}
          <Toaster position="bottom-right" />
        </QueryClientProvider>
      </AuthProvider>
    </IframeWrapper>
  );
};
